"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { CountrySelector, } from "react-international-phone";
import { sanitizePhoneLocal } from "./phone-utils.js";
/** Preferred countries shown at the top of the selector (Argentina first). */
export const PHONE_INPUT_PREFERRED_COUNTRIES = [
    "ar",
    "uy",
    "cl",
    "py",
    "bo",
    "br",
    "us",
    "es",
];
/**
 * Country selector + plain local number input (no masks or auto-formatting).
 * Styles are loaded globally by the consumer app via `globals.css`.
 */
export function PhoneInput({ country, onCountryChange, value, onChange, error = false, disabled = false, placeholder, required, className, }) {
    return (_jsxs("div", { className: clsx("react-international-phone-input-container gruv-phone-input", error && "gruv-phone-input--error", className), children: [_jsx(CountrySelector, { selectedCountry: country, onSelect: (selected) => onCountryChange(selected.iso2), preferredCountries: PHONE_INPUT_PREFERRED_COUNTRIES, disabled: disabled, buttonClassName: "gruv-phone-input__country-button" }), _jsx("input", { type: "tel", inputMode: "numeric", autoComplete: "tel-national", disabled: disabled, required: required, placeholder: placeholder, value: value, onChange: (event) => onChange(sanitizePhoneLocal(event.target.value)), className: "react-international-phone-input gruv-phone-input__field" })] }));
}
